module.exports = __webpack_public_path__ + "img/banner-Garantia_1920x660px.719ff9f2.jpg";